import { useStoreConfig } from '~/store/storeConfig'
import { useIdentity } from '~/store/identity'
import pushToKlaviyoQueue from '~/utils/thirdPartyTrackers/Klaviyo/pushToKlaviyoQueue'

export default defineNuxtPlugin(async (_nuxtApp) => {
  const site = useStoreConfig().getSite

  const klaviyoKey = site?.klaviyo_key || null

  if (klaviyoKey) {
    useHead({
      script: [
        {
          src: `//static.klaviyo.com/onsite/js/klaviyo.js?company_id=${klaviyoKey}`,
          defer: true,
        },
      ],
    })

    const user = await useIdentity().getUser()

    if (typeof window !== 'undefined') {
      ;(window as any)._loggedIn = user !== null
      ;(window as any)._learnq = (window as any)._learnq || []

      if (user !== null) {
        pushToKlaviyoQueue([
          'identify',
          {
            $email: user.email,
            $first_name: user.first_name,
            $last_name: user.last_name,
          },
        ])
      }
    }
  }
})
